import { createFileRoute, redirect } from '@tanstack/react-router';

import { ENABLE_CHAT } from '~/config/environment';
import { UUID } from '~/utils/uuid';

export const Route = createFileRoute('/_authenticated/chat/')({
  validateSearch: (search: Record<string, string>): { q?: string } => {
    return {
      q: search.q,
    };
  },
  beforeLoad({ search }) {
    if (!ENABLE_CHAT) {
      throw redirect({ to: '/' });
    }

    const uuid = UUID();

    throw redirect({
      to: '/chat/$chatId',
      params: { chatId: uuid },
      search,
    });
  },
});
